import { useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import ServiceAuth from "src/services/auth/authToken";
import ServicePatient from "src/services/patient/patient";
import { getExpiresToken, parseJwt } from "src/shared/global/helpers";
import ManageStorage from "src/shared/global/manageStorage";
import { historyRouteState } from "src/store/global/historyState";
import { snackbarState } from "src/store/global/snackbarState";
import { userState } from "src/store/user/userState";
import { LoginSchema } from "../schemas/LoginSchema";
import { errorsReservationUserState, valuesFormReservationUserState } from "../state/atoms";

const useAuthPatient = () => {
    const [valuesFormReservationUser, setValuesFormReservationUser] = useRecoilState(valuesFormReservationUserState);
    const [errorsReservationUser, setErrorsReservationUser] = useRecoilState(errorsReservationUserState);
    const setUser = useSetRecoilState(userState);
    const setSnackbar = useSetRecoilState(snackbarState);
    const [loading, setLoading] = useState(false);
    const historyRoute = useRecoilValue(historyRouteState);


    const handleChange = (ev) => {
        let { name, value } = ev.target;
        if (errorsReservationUser.hasOwnProperty(name)) {
            setErrorsReservationUser({ ...errorsReservationUser, [name]: [] });
        }

        if (value === undefined) value = '';

        setValuesFormReservationUser({
            ...valuesFormReservationUser,
            [name]: value
        })
    }


    const handleLoginUser = async () => {
        setLoading(true)
        try {

            const loginSchema = new LoginSchema();
            const bodyValidate = await loginSchema.isValidSchema({ ...valuesFormReservationUser });

            if (bodyValidate.ok === false) {
                setErrorsReservationUser((currentState) => ({
                    ...currentState,
                    ...bodyValidate.dataErrors
                }))

                return Promise.reject(bodyValidate);
            }

            const { data } = await ServiceAuth.loginUser(valuesFormReservationUser);

            ManageStorage.setItemStorage("tokenUser", data.accessToken);
            const detailUser = await getDetailPatient();

            const payload = {
                ...detailUser,
            }

            setUser((currentState) => ({
                ...currentState,
                isAuthenticated: true,
                payload: {
                    ...payload
                }
            }))

            autoLogoutWhenExpiredToken();

            return payload;
        } catch (error) {
            return Promise.reject(error)
        } finally {
            setLoading(false);
        }
    }

    const handleLogoutUser = () => {
        const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
        if(tokenUser) {
            ManageStorage.removeItemFromStorage("tokenUser");
            setUser((currentState) => ({
                ...currentState,
                isAuthenticated: false,
                payload: null
            }));
    
            setSnackbar({
                openAlert: true,
                severity: "info",
                text: "Su sesión ha finalizado",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });
    
            historyRoute?.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`)
        }
    }

    const autoLogoutWhenExpiredToken = () => {
        const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
        if (tokenUser) {
            const payloadToken = parseJwt(tokenUser);
            const timeExpired = getExpiresToken(payloadToken.exp);

            setTimeout(() => {
                handleLogoutUser()
            }, timeExpired - 300000);
        }
    }

    const getDetailPatient = async () => {
        const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
        try {
            if (tokenUser) {
                const payloadToken = parseJwt(tokenUser);
                const userRut = payloadToken.Username;

                const { data } = await ServicePatient.getDetail(userRut);
                let dataUser = data.data;

                dataUser = {
                    ...dataUser,
                    "uswFonoMovil": dataUser.uswFonoMovil !== "" ? dataUser.uswFonoMovil : null,
                    "uswFonoFijo1": dataUser.uswFonoFijo1 === null || dataUser.uswFonoFijo1 === "" ? null : dataUser.uswFonoFijo1,
                    "uswCodFonoFijo1": dataUser.uswCodFonoFijo1 === null || dataUser.uswCodFonoFijo1 === "" ? null : dataUser.uswCodFonoFijo1,
                    "usuFonoCompleto": dataUser.uswFonoFijo1 !== "" ? dataUser.uswFonoFijo1 : null,
                    "isaCodigo": dataUser.isaCodigo !== "" ? dataUser.isaCodigo : null
                }

                // setTimeout(() => {
                    // setUser((currentState) => ({
                    //     ...currentState,
                    //     payload: {
                    //         ...dataUser
                    //     }
                    // }))

                // }, 100)

                setUser((currentState) => ({
                    ...currentState,
                    payload: {
                        ...dataUser
                    }
                }))

                return dataUser;
            }

            return null;
        } catch (error) {
            return Promise.reject(error)
        }
    }


    return {
        handleChange,
        handleLoginUser,
        handleLogoutUser,
        getDetailPatient,
        autoLogoutWhenExpiredToken,
        loading
    }
}

export default useAuthPatient;